export default __webpack_public_path__ + "static/media/sejan2.3f7a5fdb.png";